
document.addEventListener("DOMContentLoaded", function () {

  function initVideos() {

    const videoWrappers = document.querySelectorAll("#without-button");

    videoWrappers.forEach((wrapper) => {

      const video = wrapper.querySelector("video");
      const button = wrapper.querySelector("button");

      if (!video || !button) return;

      // autoplay setup
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.muted = true;

      video.play().catch(() => {});

      updateButton(video, button);

      button.addEventListener("click", function (e) {

        e.preventDefault();

        video.muted = !video.muted;

        updateButton(video, button);

      });

    });

  }

  function updateButton(video, button) {

    const svg = button.querySelector("svg");

    if (!svg) return;

    // find or create span
    let text = button.querySelector("span");

    // MUTED
    if (video.muted) {

      if (!text) {
        text = document.createElement("span");
        button.appendChild(text);
      }

      text.textContent = "";

      svg.innerHTML = `
        <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path>
        <line x1="22" x2="16" y1="9" y2="15"></line>
        <line x1="16" x2="22" y1="9" y2="15"></line>
      `;

    }

    // UNMUTED
    else {

      if (text) {
        text.textContent = "";
      }

      svg.innerHTML = `
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
      `;

    }

  }

  initVideos();

  function initVideoCards() {

    const videoWrappers = document.querySelectorAll(".with-button");

    videoWrappers.forEach((wrapper) => {

      const video = wrapper.querySelector("video");
      const playButton = wrapper.querySelector(".play");
      const soundButton = wrapper.querySelector(".sound");

      if (!video || !playButton || !soundButton) return;

      // video setup
      video.loop = true;
      video.playsInline = true;
      video.muted = true;

      // initial UI
      updatePlayButton(video, playButton);
      updateSoundButton(video, soundButton);

      // PLAY / PAUSE
      playButton.addEventListener("click", function (e) {

        e.preventDefault();
        e.stopPropagation();

        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }

        updatePlayButton(video, playButton);

      });

      // SOUND MUTE / UNMUTE
      soundButton.addEventListener("click", function (e) {

        e.preventDefault();
        e.stopPropagation();

        // IF VIDEO IS PAUSED + MUTED
        // then play video first
        if (video.paused && video.muted) {

          video.play();

          updatePlayButton(video, playButton);

        }

        // toggle mute
        video.muted = !video.muted;

        updateSoundButton(video, soundButton);

      });

      // sync play button UI
      video.addEventListener("play", function () {
        updatePlayButton(video, playButton);
      });

      video.addEventListener("pause", function () {
        updatePlayButton(video, playButton);
      });

    });

  }

  // PLAY / PAUSE BUTTON
  function updatePlayButton(video, button) {

    const svg = button.querySelector("svg");

    if (!svg) return;

    // PLAYING = pause icon
    if (!video.paused) {

      button.setAttribute(
        "class",
        "pause absolute inset-0 m-auto flex h-12 w-12 items-center justify-center rounded-full bg-paper/90 text-ink shadow-soft transition hover:scale-110 opacity-0 group-hover:opacity-100"
      );

      svg.setAttribute(
        "class",
        "lucide lucide-pause h-5 w-5 fill-current"
      );

      svg.innerHTML = `
        <rect x="14" y="4" width="4" height="16" rx="1"></rect>
        <rect x="6" y="4" width="4" height="16" rx="1"></rect>
      `;

    }

    // PAUSED = play icon
    else {

      button.setAttribute(
        "class",
        "play absolute inset-0 m-auto flex h-12 w-12 items-center justify-center rounded-full bg-paper/90 text-ink shadow-soft transition hover:scale-110 opacity-100"
      );
      svg.setAttribute(
        "class",
        "lucide lucide-play ml-0.5 h-5 w-5 fill-current"
      );

      svg.innerHTML = `
        <polygon points="6 3 20 12 6 21 6 3"></polygon>
      `;

    }

  }

  // SOUND BUTTON
  function updateSoundButton(video, button) {

    const svg = button.querySelector("svg");

    if (!svg) return;

    let text = button.querySelector("span");

    // MUTED
    if (video.muted) {

      // create span again if removed
      if (!text) {
        text = document.createElement("span");
        button.appendChild(text);
      }

      text.textContent = "Tap for sound";

      svg.innerHTML = `
        <path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"></path>
        <line x1="22" x2="16" y1="9" y2="15"></line>
        <line x1="16" x2="22" y1="9" y2="15"></line>
      `;

    }

    // UNMUTED
    else {

      // remove span
      if (text) {
        text.remove();
      }

      svg.innerHTML = `
        <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
      `;

    }

  }

  initVideoCards();

});
function initProductSlider() {

  const sliders = document.querySelectorAll(
    '[role="region"][aria-roledescription="carousel"]'
  );

  sliders.forEach((slider) => {

    if (slider.dataset.sliderInit === "true") return;
    slider.dataset.sliderInit = "true";

    const wrapper = slider.closest(".overflow-hidden.rounded-md");
    if (!wrapper) return;

    const track = slider.querySelector(".flex");
    const slides = [...slider.querySelectorAll('[role="group"]')];

    const thumbWrapper = wrapper.nextElementSibling;

    const thumbs = thumbWrapper
      ? thumbWrapper.querySelectorAll("button")
      : [];

    if (!track || !slides.length) return;

    // ======================
    // CLONE FIRST & LAST
    // ======================

    const firstClone = slides[0].cloneNode(true);
    const lastClone = slides[slides.length - 1].cloneNode(true);

    track.appendChild(firstClone);
    track.prepend(lastClone);

    const allSlides = track.querySelectorAll('[role="group"]');

    // ======================
    // START SLIDE
    // ======================

    let current = 6; // start from 6th slide

    let slideWidth = slider.offsetWidth;

    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = -(current * slideWidth);

    // ======================
    // SET POSITION
    // ======================

    function setPosition(withAnimation = true) {

      track.style.transition = withAnimation
        ? "transform 0.4s ease"
        : "none";

      track.style.transform =
        `translate3d(-${current * slideWidth}px,0,0)`;

      prevTranslate = -(current * slideWidth);

      updateThumbs();

    }

    // ======================
    // UPDATE THUMB
    // ======================

    function updateThumbs() {

      let activeIndex = current - 1;

      // loop fix
      if (current === 0) {
        activeIndex = slides.length - 1;
      }

      if (current === allSlides.length - 1) {
        activeIndex = 0;
      }

      thumbs.forEach((btn, i) => {

        btn.classList.remove("border-primary", "opacity-100");
        btn.classList.add("border-border", "opacity-70");

        if (i === activeIndex) {

          btn.classList.add("border-primary", "opacity-100");
          btn.classList.remove("border-border", "opacity-70");

        }

      });

    }

    // ======================
    // THUMB CLICK
    // ======================

    thumbs.forEach((btn, i) => {

      btn.addEventListener("click", () => {

        current = i + 1;

        setPosition();

      });

    });

    // ======================
    // DRAG HELPERS
    // ======================

    function getPositionX(e) {

      return e.type.includes("mouse")
        ? e.pageX
        : e.touches[0].clientX;

    }

    // ======================
    // DRAG START
    // ======================

    function dragStart(e) {

      isDragging = true;

      startX = getPositionX(e);

      currentTranslate = prevTranslate;

      track.style.transition = "none";

    }

    // ======================
    // DRAG MOVE
    // ======================

    function dragMove(e) {

      if (!isDragging) return;

      const currentX = getPositionX(e);

      const movedBy = currentX - startX;

      currentTranslate = prevTranslate + movedBy;

      track.style.transform =
        `translate3d(${currentTranslate}px,0,0)`;

    }

    // ======================
    // DRAG END
    // ======================

    function dragEnd() {

      if (!isDragging) return;

      isDragging = false;

      const movedBy = currentTranslate - prevTranslate;

      // next
      if (movedBy < -80) {
        current++;
      }

      // prev
      if (movedBy > 80) {
        current--;
      }

      setPosition();

    }

    // ======================
    // LOOP FIX
    // ======================

    track.addEventListener("transitionend", () => {

      // last clone
      if (current === allSlides.length - 1) {

        current = 1;

        setPosition(false);

      }

      // first clone
      if (current === 0) {

        current = allSlides.length - 2;

        setPosition(false);

      }

    });

    // ======================
    // TOUCH EVENTS
    // ======================

    slider.addEventListener("touchstart", dragStart);
    slider.addEventListener("touchmove", dragMove);
    slider.addEventListener("touchend", dragEnd);

    // ======================
    // MOUSE EVENTS
    // ======================

    slider.addEventListener("mousedown", dragStart);
    slider.addEventListener("mousemove", dragMove);
    slider.addEventListener("mouseup", dragEnd);
    slider.addEventListener("mouseleave", dragEnd);

    // ======================
    // PREVENT IMAGE DRAG
    // ======================

    slider.querySelectorAll("img").forEach((img) => {

      img.draggable = false;

    });

    // ======================
    // RESIZE
    // ======================

    window.addEventListener("resize", () => {

      slideWidth = slider.offsetWidth;

      prevTranslate = -(current * slideWidth);

      setPosition(false);

    });

    // ======================
    // INIT
    // ======================

    setPosition(false);

  });

}

document.addEventListener("DOMContentLoaded", initProductSlider);

document.addEventListener(
  "shopify:section:load",
  initProductSlider
);

(function () {
  function clamp(n, min, max) {
      return Math.min(max, Math.max(min, n));
  }

  function applyCompare(root, pct) {
      var overlay = root.querySelector("[data-compare-overlay]");
      var divider = root.querySelector("[data-compare-divider]");
      var handle = root.querySelector("[data-compare-handle]");
      var input = root.querySelector('input[type="range"]');
      if (!overlay || !divider || !handle || !input) return;

      var v = clamp(Number(pct), 0, 100);
      overlay.style.clipPath = "inset(0 0 0 " + v + "%)";
      divider.style.left = v + "%";
      handle.style.left = v + "%";
      if (String(input.value) !== String(v)) input.value = String(v);
  }

  function initCompare(root) {
      var input = root.querySelector('input[type="range"]');
      if (!input) return;

      function syncFromInput() {
          applyCompare(root, input.value);
      }

      input.addEventListener("input", syncFromInput);
      input.addEventListener("change", syncFromInput);

      root.addEventListener(
          "pointerdown",
          function (e) {
              if (e.target === input || input.contains(e.target)) return;
              var rect = root.getBoundingClientRect();
              var x = e.clientX - rect.left;
              var pct = clamp((x / rect.width) * 100, 0, 100);
              applyCompare(root, pct);
              input.focus({ preventScroll: true });
          },
          { passive: true }
      );

      syncFromInput();
  }

  document.querySelectorAll("[data-image-compare]").forEach(initCompare);

  function initProductReveal(root) {
      var img = root.querySelector("img");
      var overlay = root.querySelector("[data-product-reveal-overlay]");
      if (!img || !overlay) return;

      var blurOn = ["blur-[3px]", "scale-105"];

      function setRevealed(isRevealed) {
          blurOn.forEach(function (c) {
              if (isRevealed) img.classList.remove(c);
              else img.classList.add(c);
          });
          overlay.classList.toggle("hidden", isRevealed);
          root.setAttribute("aria-pressed", isRevealed ? "true" : "false");
      }

      function toggle() {
          var revealed = overlay.classList.contains("hidden");
          setRevealed(!revealed);
      }

      root.addEventListener("click", function () {
          toggle();
      });

      root.addEventListener("keydown", function (e) {
          if (e.key !== "Enter" && e.key !== " ") return;
          e.preventDefault();
          toggle();
      });

      setRevealed(false);
  }

  document.querySelectorAll("[data-product-reveal]").forEach(initProductReveal);
})();